var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216,327.4h-30.2c-13.7,0-19.4,13.2-16.5,22.6L224,450.4c6.6,8.6,17.9,8.5,26.3-3.4l54.8-97c2.8-11.8-2.8-22.6-16.5-22.6 h-26.8c10-55.1,56-90.6,111.2-90.6c62.4,0,113.2,50.8,113.2,113.2S440.9,463.2,373,463.2v45.3c90.6,0,158.5-71.1,158.5-158.5 S460.4,191.5,373,191.5C293,191.5,226.8,248.3,216,327.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.3c2e9a7f3d7685c4c5a9f91e38d9e0f0.svg";
export { ForwardRef as ReactComponent };